/** @format */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';
import { ConfirmDialog, AlertDialog } from 'src/ui/library/Dialog';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import Link from '@material-ui/core/Link';
import PrintIcon from '@material-ui/icons/Print';
import ListIcon from '@material-ui/icons/List';
import ViewListIcon from '@material-ui/icons/ViewList';
const MENU_TYPES = {
  MENU: 'MENU',
  CLOSE: 'CLOSE',
  SAVE: 'SAVE',
  HOME: 'HOME',
  DOWNLOAD_EY_PDF: 'DOWNLOAD_EY_PDF',
  DOWNLOAD_ASSIGNEE_PDF: 'DOWNLOAD_ASSIGNEE_PDF',
};

export default function ActionsBarPres({
  isPageVariant,
  isFirstPage,
  isLastPage,
  progressTitle,
  percentProgress,
  onBack,
  onClose,
  onCloseWithAction,
  onSave,
  onPrevPage,
  onNextPage,
  onMenu,
  onHome,
  onDownload,
  isMobile,
  onSubmit,
  isSubmitDisabled,
  isConfirmSubmitDialogOpen,
  toggleConfirmSubmitDialog,
  toggleAlertSubmitDialog,
  isSubmittingQuestionnaire,
  page,
  showModal,
  moveAwayShowModel,
  onCancel,
  onSubmitModal,
  isCompleteModalDialogOpen,
  isAlterDialogOpen,
  afterSubmitError,
  showSpinner,
}) {
  // const menuActionsCallbacks = {
  //   [MENU_TYPES.MENU]: onMenu,
  //   [MENU_TYPES.SAVE]: onSave,
  //   [MENU_TYPES.CLOSE]: onCloseWithAction,
  //   [MENU_TYPES.DOWNLOAD_EY_PDF]: onDownload,
  //   [MENU_TYPES.DOWNLOAD_ASSIGNEE_PDF]: onDownload,
  // };
  //   const languageId = getLangIdFromSessionStorage();
  //const languageId = 1;
  //const cordovaSetup = false;
  // const getMenuOptions = () => {
  //   return [
  //     {
  //       title: intl.get('questionnaire.actionBar.close'),
  //       type: MENU_TYPES.CLOSE,
  //     },
  //     {
  //       title: intl.get('questionnaire.actionBar.menu'),
  //       type: MENU_TYPES.MENU,
  //     },
  //     {
  //       title: intl.get('questionnaire.actionBar.save'),
  //       type: MENU_TYPES.SAVE,
  //     },

  //     {
  //       title: intl.get('questionnaire.actionBar.downloadEyPdf'),
  //       type: MENU_TYPES.DOWNLOAD_EY_PDF,
  //     },
  //     {
  //       title: intl.get('questionnaire.actionBar.downloadAssigneePdf'),
  //       type: MENU_TYPES.DOWNLOAD_ASSIGNEE_PDF,
  //     },
  //   ];
  // };

  // currentProgress is dependent upon isSubmitDisabled,
  // if Submit is enabled user should be shown 100% progress.
  // Percent Progress is percentage of Quesstionnaire creation completed,
  // but in case last page is not having any elements,  Or as soon as mandatory elements of last page are completed
  // then submit should be enabled and it should be shown 100% progress.
  const currentProgress = percentProgress;
  //const showProgressBar = typeof currentProgress === 'number';

  return showModal || moveAwayShowModel ? (
    <ConfirmDialog
      open={isCompleteModalDialogOpen}
      title={intl.get('questionnaire.showModal.title')}
      cancelText={intl.get('questionnaire.showModal.cancelText')}
      confirmText={intl.get('questionnaire.showModal.confirmText')}
      onCancel={onCancel}
      onConfirm={onSubmitModal}>
      <span>{intl.get('questionnaire.showModal.text')}</span>
    </ConfirmDialog>
  ) : (
    <div>
      {showSpinner && <ServiceSpinner downlaodSpinner={showSpinner} open={true} />}
      <section className="ssi-actions questionnaire-action-bar">
        <div className="ssi-button-wrapper">
          {!isPageVariant && (
            <div className="ssi-wrapper-cancelsave">
              {typeof onBack === 'function' && (
                <Button
                  styleType="secondary"
                  onClick={() => {
                    onBack();
                  }}
                  className="action-button">
                  {intl.get('questionnaire.actionBar.back')}
                </Button>
              )}
              {typeof onClose === 'function' && (
                <Button
                  styleType="secondary"
                  onClick={() => {
                    onClose();
                  }}
                  className="action-button">
                  {intl.get('questionnaire.actionBar.close')}
                </Button>
              )}
              {typeof onDownload === 'function' && (
                <Link
                  component="button"
                  underline="hover"
                  className="textLink-button"
                  onClick={() => {
                    onDownload(MENU_TYPES.DOWNLOAD_ASSIGNEE_PDF);
                  }}>
                  <PrintIcon />
                  {intl.get('questionnaire.actionBar.print')}
                </Link>
              )}
              {typeof onDownload === 'function' && (
                <Link
                  component="button"
                  underline="hover"
                  className="textLink-button"
                  onClick={() => {
                    onDownload(MENU_TYPES.DOWNLOAD_EY_PDF);
                  }}>
                  <PrintIcon />
                  {intl.get('questionnaire.actionBar.eyprint')}
                </Link>
              )}
            </div>
          )}
          {isPageVariant && (
            <React.Fragment>
              <span>
                <Link component="button" underline="hover" className="textLink-button" onClick={onMenu}>
                  <ListIcon />
                  {intl.get('questionnaire.actionBar.pagelist')}
                </Link>
                <Link component="button" underline="hover" className="textLink-button" onClick={onCloseWithAction}>
                  <ViewListIcon />
                  {intl.get('questionnaire.actionBar.caseview')}
                </Link>
              </span>
              <span>
                <Button
                  styleType="primary"
                  disabled={!isSubmitDisabled}
                  onClick={toggleConfirmSubmitDialog}
                  className="action-button submit-button">
                  {intl.get('questionnaire.actionBar.submit')}
                </Button>
              </span>

              <div className="pull-right-mobile">
                <Button styleType="secondary" disabled={isFirstPage} onClick={onPrevPage} className="action-button prev-button">
                  &lt; {!isMobile && intl.get('questionnaire.actionBar.back')}
                </Button>
                <Button styleType="secondary" disabled={isLastPage} onClick={onNextPage} className="action-button next-button">
                  {!isMobile && intl.get('questionnaire.actionBar.next')} &gt;
                </Button>
              </div>
            </React.Fragment>
          )}
        </div>
        {/* {showProgressBar && (
          <div className="ssi-progress-wrapper">
            <span className="progress-text">
              <b>{`'${progressTitle}' ${intl.get('questionnaire.actionBar.section')} Section`}:</b>
              &nbsp;
              {currentProgress}&#37; complete
              {intl.get('questionnaire.actionBar.progressTxt')}
            </span>
            <div className="progress-bar">
              <span className={`filled ${currentProgress === 100 ? 'filled-complete' : ''}`} style={{ width: `${currentProgress}%` }} />
            </div>
          </div>
        )} */}
      </section>
      <ConfirmDialog
        open={isConfirmSubmitDialogOpen}
        title={intl.get('questionnaire.submitDialog.title')}
        cancelText={intl.get('questionnaire.submitDialog.cancelText')}
        confirmText={intl.get('questionnaire.submitDialog.confirmText')}
        onCancel={toggleConfirmSubmitDialog}
        onConfirm={onSubmit}>
        <Fragment>
          <span>{intl.get('questionnaire.submitDialog.text')}</span> <br />
          <span>{intl.get('questionnaire.submitDialog.supportText')}</span>
        </Fragment>
        {isSubmittingQuestionnaire && (
          <span className="questionnaire-submit-dialog-spinner">
            <ServiceSpinner />
          </span>
        )}
      </ConfirmDialog>
      <AlertDialog
        open={isAlterDialogOpen}
        cancelText={intl.get('questionnaire.alertDialog.cancelText')}
        onCancel={toggleAlertSubmitDialog}
        noMaxWidthBtns={false}>
        <span>{afterSubmitError ? afterSubmitError : intl.get('questionnaire.alertDialog.text')}</span>
      </AlertDialog>
    </div>
  );
}

ActionsBarPres.propTypes = {
  isPageVariant: PropTypes.bool,
  isFirstPage: PropTypes.bool,
  isLastPage: PropTypes.bool,
  progressTitle: PropTypes.string,
  percentProgress: PropTypes.number,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onPrevPage: PropTypes.func,
  onNextPage: PropTypes.func,
  onMenu: PropTypes.func,
  onHome: PropTypes.func,
  onDownload: PropTypes.func,
  isMobile: PropTypes.bool,
  onSubmit: PropTypes.func,
  isSubmitDisabled: PropTypes.bool,
  isConfirmSubmitDialogOpen: PropTypes.bool,
  toggleConfirmSubmitDialog: PropTypes.func,
  toggleAlertSubmitDialog: PropTypes.func,
  isSubmittingQuestionnaire: PropTypes.bool,
  page: PropTypes.any,
  showModal: PropTypes.bool,
  moveAwayShowModel: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmitModal: PropTypes.func,
  isCompleteModalDialogOpen: PropTypes.any,
  isAlterDialogOpen: PropTypes.any,
  afterSubmitError: PropTypes.any,
  showSpinner: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/ui/features/Questionnaire/presentational/ActionsBarPres.js